import React from 'react';
import { motion } from 'framer-motion';
import { FlameIcon } from 'lucide-react';
import { trackAddToCart } from '../lib/metaPixel';
export function TopBar() {
  return <div className="text-white py-3 px-4 sticky top-0 z-50 shadow-md bg-[#70C100]" data-id="element-227">
      <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-center text-center sm:text-left gap-2 sm:gap-4" data-id="element-228">
        <div className="flex items-center gap-2 text-sm sm:text-base font-medium" data-id="element-229">
          <FlameIcon className="w-5 h-5 text-accent-200 animate-pulse" data-id="element-230" />
          <span data-id="element-231">
            Oferta por tiempo limitado — Chau Hígado Graso + 6 bonos gratis por
            solo $14.999 ARS
          </span>
        </div>
        <a href="https://comesinmiedo.com/cart/add?id=48318516461822&quantity=1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} className="text-xs sm:text-sm font-bold px-4 py-1.5 rounded-full hover:bg-accent-50 transition-colors whitespace-nowrap text-[#FFFFFF] bg-[#F5880B]" data-id="element-232">
          Acceder Ahora
        </a>
      </div>
    </div>;
}